"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMsgProposalContent = void 0;
function isMsgProposalContent(object) {
    return 'getEncoded' in object;
}
exports.isMsgProposalContent = isMsgProposalContent;
//# sourceMappingURL=IMsgProposalContent.js.map